export default {
	email: /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\.]*)[a-z0-9_'+\-]@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i,
	phoneWithNumbers: /^-?\d*(\.\d*)?$/,
	phoneWithNumbersAndDashes: /^\d+(-\d+)*-?$/
};
